var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "#A1A1A1",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1.577c-.86 0-1.686.35-2.295.971a3.36 3.36 0 0 0-.95 2.346v2.497h6.49V4.894c0-.88-.342-1.724-.95-2.346A3.2 3.2 0 0 0 8 1.577m4.787 5.814V4.894a4.95 4.95 0 0 0-1.402-3.46A4.74 4.74 0 0 0 8 0C6.73 0 5.513.516 4.615 1.433a4.95 4.95 0 0 0-1.402 3.461v2.497h-.835C1.064 7.39 0 8.479 0 9.82v5.748C0 16.912 1.064 18 2.378 18h11.245C14.936 18 16 16.912 16 15.57V9.82c0-1.342-1.064-2.43-2.377-2.43zM2.377 8.967a.845.845 0 0 0-.835.854v5.748c0 .472.374.854.836.854h11.245a.845.845 0 0 0 .835-.854V9.821a.845.845 0 0 0-.835-.854z",
    clipRule: "evenodd"
  })));
};
export default SvgLock;